import React from 'react';
// import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import { Formik } from 'formik';
import { ModalWithStyles } from './ModalWithStyles';
// import { endpointEnum } from '../../../services/rest/makeAPIRequest';

export function DeleteCadenceScheduledModal({
  cadenceId,
  handleClose,
  show,
  handleDeletion,
}) {
  return (
    <Formik
      onSubmit={async (values, actions) => {
        handleDeletion(values.cadenceId);
        actions.resetForm({});
        handleClose();
      }}
      enableReinitialize={true}
      initialValues={{
        cadenceId: cadenceId ?? '',
      }}
    >
      {(formik) => (
        <>
          <form
            className="form form-label-right"
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <ModalWithStyles
              onSubmit={formik.handleSubmit}
              title="Cancel All Upcoming Cadence Events"
              aria-labelledby="example-modal-sizes-title-md"
              show={show}
              onHide={handleClose}
              isSubmitting={formik.isSubmitting}
              isLoading={formik.isSubmitting}
              deleteDialog={true}
              size="xs"
            >
              <p>
                Are you sure you want to cancel all upcoming events for contacts
                in this Cadence? This will stop all scheduled SMS, Calls, and
                other actions from being executed, regardless of where the
                contacts are currently in the process.
              </p>
              <p>This operation cannot be undone.</p>
            </ModalWithStyles>
          </form>
        </>
      )}
    </Formik>
  );
}
